<template>
  <div class="wrapper">
    <div class="splash">
      <lottie class="splash-screen" :options="splashDefault" />
    </div>
  </div>
</template>
<script>
import lottie from "@/components/Lottie";
import * as splashData from "@/assets/animations/splash/splash.json";

export default {
  data() {
    return {
      splashDefault: { animationData: splashData.default, loop: false }
    };
  },

  components: {
    lottie
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $zIndex + 999;
  background-color: #333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .splash {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 50%;

    .splash-screen {
      transform: translateY(-50%) scale(2);

      @include mobile {
        transform: translateY(-50%) scale(3.5);
      }
    }
  }
}
</style>
